export enum AdminType {
  CEO = 1,
  COO = 2,
  CMO = 3,
  MARKETING = 4,
}
